import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import {
  apiRequest,
  ServiceBase,
} from 'services';

import { User } from '@models/user';

@Injectable({
  providedIn: "root"
})
export class RegistrationService extends ServiceBase {
  RegistrationSuccess: Subject<any>;
  RegistrationB2BSuccess: Subject<any>;
  UserIDFinder: Subject<any>;
  profileSuccess$: Subject<any>;

  
  InsertFamilyDetails$: Subject<any>;
  GetFamilyDetailsByUser$: Subject<any>;
  DeleteFamilyDetails$: Subject<any>;
  UpdateFamilyDetails$: Subject<any>;
  GetEmployeeRoles$: Subject<any>;
  GetReportingManagers$: Subject<any>;

  GetUserMenuRolesB2CUser$: Subject<any>;


  constructor(http: HttpClient) {
    super(http);

    this.GetUserMenuRolesB2CUser$=new Subject<any>();
    this.RegistrationSuccess = new Subject<any>();
    this.RegistrationB2BSuccess = new Subject<any>();
    this.UserIDFinder = new Subject<any>();
    this.profileSuccess$ = new Subject<any>();
    this.InsertFamilyDetails$ = new Subject<any>();
    this.GetFamilyDetailsByUser$ = new Subject<any>();
    this.DeleteFamilyDetails$ = new Subject<any>();
    this.UpdateFamilyDetails$ = new Subject<any>();
    this.GetEmployeeRoles$ = new Subject<any>();
    this.GetReportingManagers$ = new Subject<any>();
  }

  
  getB2CUserRoles(userObj: any) {
    return this.post<any>({
      url: "Login/B2CUserMenus/v1/MenusForB2CUser",
      data: userObj,
      onNotify: this.GetUserMenuRolesB2CUser$
    });
  }

  getEmployeeRoles(userObj: any) {
    return this.post<any>({
      url: "Common/YtbOrgRoles/v1/GetOrgRoles",
      data: userObj,
      onNotify: this.GetEmployeeRoles$
    });
  }

  getReportingManagersDetails(userObj: any) {
    return this.post<any>({
      url: "Common/YtbB2CCustomer/v1/getemployebyOrgNbranch",
      data: userObj,
      onNotify: this.GetReportingManagers$
    });
  }

  register(signupFormObj: User) {
    signupFormObj.Device_Type = 1;
    this.post<any>({
      url: "Login/YTBB2CCustomer/v1/B2CRegistration",
      data: signupFormObj,
      onNotify: this.RegistrationSuccess,
      operationKey: "RegisterFailed",
      handleErrorThroughSubject: true,
    } as apiRequest<any>);
  }

  agentRegister(signupFormObj: User) {
    signupFormObj.Device_Type = 1;
    this.post<any>({
      url: "Login/YTBB2CCustomer/v1/B2BRegistration",
      data: signupFormObj,
      onNotify: this.RegistrationB2BSuccess,
      operationKey: "RegisterFailed",
      handleErrorThroughSubject: true,
    } as apiRequest<any>);
  }

  /**
   * @author : Sindhuri Punati
   * @description : This method will get the email in the system
   * @apiEndPoint : 'user/isUserIdAvailable/'
   * @param email
   */
  getUserId(userObj: any) {
    return this.post<any>({
      url: "Common/UserCredentials/v1/UserValidation",
      data: userObj,
      onNotify: this.UserIDFinder
    });
  }

  getProfileDetails(userid: any) {
    this.post<any>({
      url: 'Login/YTBB2CCustomer/v1/YTBCustomerPersonalInfoByUserid',
      data: userid,
      onNotify: this.profileSuccess$,
    } as apiRequest<any>);
  }

  

  deleteFamilyDetails(userid: any) {
    this.post<any>({
      url: 'Common/FamilyDetails/v1/DeleteFamilyDetails',
      data: userid,
      onNotify: this.DeleteFamilyDetails$,
    } as apiRequest<any>);
  }

  

  getFamilyDetailsByUserId(userid: any) {
    this.post<any>({
      url: 'Common/FamilyDetails/v1/GetByFamilyDetails',
      data: userid,
      onNotify: this.GetFamilyDetailsByUser$,
    } as apiRequest<any>);
  }

  

  updateFamilyDetails(userid: any) {
    this.post<any>({
      url: 'Common/FamilyDetails/v1/UpdateFamilyDetails',
      data: userid,
      onNotify: this.UpdateFamilyDetails$,
    } as apiRequest<any>);
  }

  

  insertFamilyDetails(userid: any) {
    this.post<any>({
      url: 'Common/FamilyDetails/v1/InsertFamilyDetails',
      data: userid,
      onNotify: this.InsertFamilyDetails$,
    } as apiRequest<any>);
  }
}
